import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";
import SidebarGenericButton from "./SidebarGenericButton";
import { toast } from "react-toastify";

const SidebarSurveyButton = () => {
  const rootStore = useContext(RootStoreContext);
  const {isMobileMediaQuery} = rootStore.responsiveStore;
  const { setIsModalOpen, surveyButtonVisible } = rootStore.surveyStore;
  const [t] = useTranslation(["translation"], translationHookOptions);


  return (
    <>
      {surveyButtonVisible ? (
        <div className={classNames(isMobileMediaQuery? "col-6 mobileSidebarButtonContainer" : "", "pt-0 pb-0")}>
          <Link to="#" className=" pb-0">
            <SidebarGenericButton
              icon={"far fa-poll-people"}
              label={t("sidebar_btn_surveys")}
              isActive={false}
              onClick={() => setIsModalOpen(true)}
            />
          </Link>
        </div>
      ) : null}
    </>
  );
};

export default observer(SidebarSurveyButton);
